// The organizations a user opened most recently, newest first, kept per user in this browser.
// Organization-first navigation (IT Glue: choose the organization, then its passwords or
// configurations) uses the first as "last used" and the rest as shortcuts. Never throws: storage
// may be blocked, and then there is simply no history.

export interface RecentOrg {
  id: string;
  name: string;
}

const MAX = 8;
const key = (userId: string) => `denwen-msp.recent-orgs.${userId}`;

export function recentOrgs(userId: string | null | undefined): RecentOrg[] {
  if (!userId) return [];
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(key(userId)) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((o): o is RecentOrg => typeof o?.id === 'string' && typeof o?.name === 'string').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

/** Moves the organization to the front of the user's list. */
export function rememberOrg(userId: string | null | undefined, org: RecentOrg) {
  if (!userId) return;
  try {
    const next = [{ id: org.id, name: org.name }, ...recentOrgs(userId).filter((o) => o.id !== org.id)].slice(0, MAX);
    localStorage.setItem(key(userId), JSON.stringify(next));
  } catch {
    // Storage blocked or full: no history.
  }
}

/** Drops an organization the user can no longer open (deleted, or access removed). */
export function forgetOrg(userId: string | null | undefined, orgId: string) {
  if (!userId) return;
  try {
    localStorage.setItem(key(userId), JSON.stringify(recentOrgs(userId).filter((o) => o.id !== orgId)));
  } catch {
    // Storage blocked: nothing to forget.
  }
}
